import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackEnabledIncludeNestedItemsParams = {
  totalSelectionCount: number;
};

export const useTrackEnabledIncludeNestedItems = () => {
  const { track } = useAnalyticsUtilities();

  const trackEnabledIncludeNestedItems = useCallback(
    (params: TrackEnabledIncludeNestedItemsParams) => {
      track('enabled_include_nested_items', params);
    },
    [track],
  );

  return { trackEnabledIncludeNestedItems };
};
